"use client";
import { styled } from "@mui/material/styles";
import Typography, { TypographyProps } from "@mui/material/Typography";

export const InterTypography = styled(Typography)<TypographyProps>({
	fontFamily: "Inter, sans-serif",
});
